import PropTypes from "prop-types";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { getTagStyle } from "helpers/tags";

/** A tag in its own color; a disabled tag is shown muted. */
const TagBadge = ({ tag, className }) => (
  <Badge
    variant={tag.enabled ? "default" : "outline"}
    style={getTagStyle(tag)}
    className={cn(
      "tw:h-auto tw:max-w-full tw:min-w-0 tw:justify-start tw:text-left tw:whitespace-normal tw:wrap-anywhere",
      className
    )}
  >
    {tag.name}
  </Badge>
);

TagBadge.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    enabled: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
};

export default TagBadge;
